import moment from 'moment';
import { TableCustomCell } from '../../../../../component/table/components/TableCustomCell';
import { TableCustomHeader } from '../../../../../component/table/components/TableCustomHeader';
import { APP_DATE_TIME_FORMAT } from '../../../../../utils/Constant';

const formatInsuranceDate = (value: string) => {
	if (!value) return '';

	return moment(value, 'YYYYMMDDHHmm').format(APP_DATE_TIME_FORMAT);
};

export const INSURANCE_CHECK_RESULT_COLUMNS: ReadonlyArray<any> = [
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="STT"
				className="text-center text-light min-w-40"
			/>
		),
		id: 'order',
		Cell: ({ ...props }) => (
			<TableCustomCell className="text-center" data={props.row.index + 1} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title=""
				className="text-center text-light spaces min-w-150"
			/>
		),
		id: 'field-name',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="text-start min-w-150"
				data={props?.data[props.row.index]?.fieldName}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Thông tin thẻ đã nhập"
				className="text-center text-light min-w-300"
			/>
		),
		id: 'patient-input',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="min-w-300"
				data={props?.data[props.row.index]?.patientInput}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Thông tin thẻ trên cổng BHXH"
				className="text-center text-light min-w-300"
			/>
		),
		id: 'patient-insurance',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="min-w-300"
				data={props?.data[props.row.index]?.patientInsurance}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Kết quả"
				className="text-center text-light spaces min-w-100"
			/>
		),
		id: 'result',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="text-center min-w-100"
				data={
					props?.data[props.row.index]?.result ? (
						<p className="text-green m-0">Thông tin trùng khớp</p>
					) : (
						''
					)
				}
			/>
		),
	},
];

export const MEDICAL_HISTORY_COLUMNS: ReadonlyArray<any> = [
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Mã Hồ Sơ"
				className="text-center text-light min-w-120"
			/>
		),
		id: 'record-code',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-120" data={props?.data[props.row.index]?.maHoSo} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Mã Cơ Sở KCB"
				className="text-center text-light min-w-120"
			/>
		),
		id: 'place-code',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-120" data={props?.data[props.row.index]?.maCSKCB} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Tên Cơ Sở KCB"
				className="text-center text-light min-w-200"
			/>
		),
		id: 'place-name',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-200" data={props?.data[props.row.index]?.tenCSKCB} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Ngày Vào"
				className="text-center text-light min-w-100"
			/>
		),
		id: 'date-start',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="text-center min-w-100"
				data={formatInsuranceDate(props?.data[props.row.index]?.ngayVao)}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Ngày Ra"
				className="text-center text-light min-w-100"
			/>
		),
		id: 'date-end',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="text-center min-w-100"
				data={formatInsuranceDate(props?.data[props.row.index]?.ngayRa)}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Tên Bệnh"
				className="text-center text-light min-w-200"
			/>
		),
		id: 'diagnosis',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-200" data={props?.data[props.row.index]?.tenBenh} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Tình Trạng"
				className="text-center text-light min-w-100"
			/>
		),
		id: 'status',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-100" data={props?.data[props.row.index]?.tinhTrang} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Kết quả điều trị"
				className="text-center text-light min-w-150"
			/>
		),
		id: 'result',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-150" data={props?.data[props.row.index]?.kqDieuTri} />
		),
	},
];

export const VERIFY_HISTORY_COLUMNS: ReadonlyArray<any> = [
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="User Kiểm Tra"
				className="text-center text-light min-w-125"
			/>
		),
		id: 'username',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-125" data={props?.data[props.row.index]?.userKT} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Thời Gian Kiểm Tra"
				className="text-center text-light min-w-150"
			/>
		),
		id: 'time',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="text-center min-w-150"
				data={formatInsuranceDate(props?.data[props.row.index]?.thoiGianKT)}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Tên Cơ Sở KCB"
				className="text-center text-light min-w-150"
			/>
		),
		id: 'name',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-150" data={props?.data[props.row.index]?.tenCSKCB} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Thông Báo"
				className="text-center text-light min-w-300"
			/>
		),
		id: 'notify',
		Cell: ({ ...props }) => (
			<TableCustomCell className="min-w-300" data={props?.data[props.row.index]?.thongBao} />
		),
	},
];
